function extractFirstName(fullName: string): string {
  return fullName.split(/\s+/)[0] || fullName;
}

export default extractFirstName;
